import styles from "./index.module.css";

const Checkbox = ({ name, onChange }: any) => {
  return (
    <input
      className={styles.customCheckbox}
      type="checkbox"
      name={name}
      id={name}
      onChange={(e: any) => {
        onChange && onChange(e.target.checked);
      }}
    />
  );
};

export default Checkbox;
